/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Findings({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M4.98 8.799h6.164m-6.164 0V3.144a1 1 0 0 1 .548-.892l2.024-1.027a1 1 0 0 1 .89-.008l2.139 1.04a1 1 0 0 1 .563.899v5.643m-6.164 0H3.377m1.603 0-.753 4.511M11.144 8.8h1.608m-1.608 0 .08.472m0 0 .627 3.746m-.628-3.746-6.996 4.04M12.15 14.8l-.2-1.2-.098-.583M3.979 14.8l.248-1.49m7.624-.293L8.762 14.8" /><path fill="currentColor" d="M8.065 3.74a.495.495 0 0 0-.464.322l-.037.103c-.08.216-.105.268-.133.307a.5.5 0 0 1-.123.122c-.045.032-.106.06-.33.147l-.097.038a.496.496 0 0 0 0 .922l.098.039c.223.087.284.113.33.146q.074.053.122.123c.028.04.052.091.133.307l.037.102a.496.496 0 0 0 .928 0l.038-.102c.08-.215.104-.268.132-.307a.5.5 0 0 1 .123-.123c.046-.032.107-.06.33-.146L9.25 5.7a.495.495 0 0 0 0-.922L9.15 4.74c-.223-.087-.283-.115-.329-.147a.5.5 0 0 1-.123-.122c-.029-.04-.051-.091-.132-.307l-.038-.103-.032-.07a.5.5 0 0 0-.432-.252" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M2.5 3.447 1 3m1.5 3.216L1 6.663M13.5 3.447 15 3m-1.5 3.216 1.5.447" /></svg>;
}
;